import { render } from "./CodecoCoarri.vue?vue&type=template&id=cb96da78&scoped=true"
import script from "./CodecoCoarri.vue?vue&type=script&lang=js"
export * from "./CodecoCoarri.vue?vue&type=script&lang=js"

import "./CodecoCoarri.vue?vue&type=style&index=0&id=cb96da78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb96da78"]])

export default __exports__